export const SHOW_FETCH_REQUESTED = 'SHOW_FETCH_REQUESTED';
export const SHOW_FETCH_SUCCEEDED = 'SHOW_FETCH_SUCCEEDED';
export const SHOW_FETCH_FAILED = 'USER_FETCH_FAILED';
export const SHOW_FETCH_CANCEL = 'USER_FETCH_CANCEL';

export const EPISODE_FETCH_REQUESTED = 'EPISODE_FETCH_REQUESTED';
export const EPISODE_FETCH_SUCCEEDED = 'EPISODE_FETCH_SUCCEEDED';
export const EPISODE_FETCH_FAILED = 'EPISODE_FETCH_FAILED';
export const EPISODE_FETCH_CANCEL = 'EPISODE_FETCH_CANCEL';

export const EPISODES_FETCH_REQUESTED = 'EPISODES_FETCH_REQUESTED';
export const EPISODES_FETCH_SUCCEEDED = 'EPISODES_FETCH_SUCCEEDED';
export const EPISODES_FETCH_FAILED = 'EPISODES_FETCH_FAILED';
export const EPISODES_FETCH_CANCEL = 'EPISODES_FETCH_CANCEL';

export const SEASONS_DIVIDED = 'SEASONS_DIVIDED';
